import { render } from "./settings-backup-dropdown-box.vue?vue&type=template&id=910da748&scoped=true&ts=true"
import script from "./settings-backup-dropdown-box.vue?vue&type=script&lang=ts"
export * from "./settings-backup-dropdown-box.vue?vue&type=script&lang=ts"

import "./settings-backup-dropdown-box.vue?vue&type=style&index=0&id=910da748&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-910da748"]])

export default __exports__